

export const GEO_DIM_CANDIDATES = {
  states:   ["state_fips", "STATE", "state"],
  counties: ["county_fips", "COUNTYFP20", "full_fips"],
  cd:       ["district", "CD118"],
  zipcodes: ["GEOID_ZCTA5_20", "full_fips", "zip", "zipcode"],
};

export function resolveJoinKeys(geoLevel, sampleRow, sampleFeatureProps) {
  const candidates = GEO_DIM_CANDIDATES[geoLevel] || [];
  let rowKey = null, featureKey = null;

  for (const c of candidates) {
    if (c in (sampleRow || {})) { rowKey = c; break; }
  }
  if (!rowKey) {
    if ("area_cd" in (sampleRow || {})) rowKey = "area_cd";
    else if ("name" in (sampleRow || {})) rowKey = "name";
  }

  if ("area_cd" in (sampleFeatureProps || {})) featureKey = "area_cd";
  else {
    for (const c of candidates) {
      if (c in (sampleFeatureProps || {})) { featureKey = c; break; }
    }
    if (!featureKey) featureKey = "name";
  }

  return { rowKey, featureKey };
}
